import clsx from 'clsx';
import React from 'react';
import {KTIcon} from '@/_metronic/helpers'

interface StatusCellProps {
  status: string;
}

export const StatusCell = ({ status }: StatusCellProps) => {
  const getIcon = (status: string) => {
    switch (status) {
      case 'pending':
        return <KTIcon iconName="time" className='fs-1 text-warning' />;
      case 'archived':
        return <KTIcon iconName="archive" className='fs-1 text-info' />;
      case 'answered':
        return <KTIcon iconName="arrow-circle-right" className='fs-1 text-primary' />;
      case 'resolved': 
        return <KTIcon iconName="double-check" className='fs-1 text-success' />;
      case 'closed':
        return <KTIcon iconName="cross-square" className='fs-1 text-secondary' />;
      default:
      return <></>
    }
  }

  return (
    <span className="d-inline-flex align-items-center">
      {getIcon(status)}
      <span className={clsx('ms-2 badge', {
        'badge-warning': status === 'pending',
        'badge-info': status === 'archived',
        'badge-primary': status === 'answered',
        'badge-success': status === 'resolved',
        'badge-secondary': status === 'closed',

      })}>
        {status}
      </span>
    </span>
  )
};

interface MessagesCellProps {
  messages: number;
}

export const MessagesCell = ({ messages }: MessagesCellProps) => (
  <span className="d-inline-flex align-items-center">
    <span className="me-2">{messages}</span>
    <KTIcon iconName="messages" className='fs-1' />
  </span>
);


interface TypeCellProps {
  type: string;
}

export const TypeCell = ({ type }: TypeCellProps) => (
  <>{type}</>
);
